import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.GetFileExtensionFilter,
    dependencies: [
    ]
})
export class GetFileExtensionFilter {
    constructor() {
        return ((path: string) => {

            let filename = path.substring(path.lastIndexOf("/") + 1);

            return filename.substring(path.lastIndexOf(".") + 1);
        }) as any;
    }

}
